import FacilityHomeScreen from './FacilityHomeScreen';
export default FacilityHomeScreen;
